// import styles from "./PageLayout.module.css";
import Footer from "../Footer/Footer.jsx";
import Header from "../Header/Header.jsx";

function PageLayout({ children, id, headerCTAHandler = () => {} }) {
    return (
        <div id={id}>
            <Header CTAHandler={headerCTAHandler} />
            <main>{children}</main>
            <Footer />
        </div>
    );
}

export default PageLayout;
